import axios from "axios";
import React, { useState } from "react";
import API_URL from "../../../config";
import SuccessModal from "../../utility/SuccessModal";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from 'uuid';

const Sideform = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [useruuid] = useState(uuidv4());

  const handleChange = (e) => {
    const { name, value } = e?.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const payload = {
      ...formData,
      useruuid,
      rewards: "None",
      pageUrl: window.location.href,
    };
    console.log("pageurl", window.location.href);

    console.log("PAYLOAD", payload)
    try {
      await axios.post(`${API_URL}/layout/send-mail`, payload);
      setFormData({ name: "", email: "", phone: "" });
      toast.success("form filled successfully");
      setShowModal(true);
    } catch (error) {
      console.error("Submission Error:", error);
      toast.error("error is submitting form");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div
        className="elementor-element elementor-element-c1b31eb e-con-full e-flex e-con e-child"
        data-id="c1b31eb"
        data-element_type="container"
        data-settings='{"background_background":"classNameic"}'
      >
        <div
          className="elementor-element elementor-element-2250fe1 e-con-full e-flex e-con e-child"
          data-id="2250fe1"
          data-element_type="container"
          id="consultation"
          data-settings='{"sticky":"top","background_background":"classNameic","sticky_parent":"yes","sticky_offset":150,"sticky_on":["desktop","tablet","mobile"],"sticky_effects_offset":0,"sticky_anchor_link_offset":0}'
        >
          <div
            className="elementor-element elementor-element-5d27c37 elementor-widget elementor-widget-spacer"
            data-id="5d27c37"
            data-element_type="widget"
            data-widget_type="spacer.default"
          >
            <div className="elementor-spacer">
              <div className="elementor-spacer-inner"></div>
            </div>
          </div>
          <div
            className="pt-3 pb-1"
            data-id="b6ab399"
            data-element_type="widget"
            data-widget_type="heading.default"
            style={{
              background: "#c69933",
              color: "white",
              textAlign: "center",
            }}
          >
            <h2 className=" " style={{ fontSize: "20px", color: "white" }}>
              Fill in your details to claim up to 30% discount!
            </h2>
          </div>
          <div
            className="elementor-element elementor-element-4b5d764 elementor-widget elementor-widget-shortcode"
            data-id="4b5d764"
            data-element_type="widget"
            data-widget_type="shortcode.default"
          >
            <div className="elementor-shortcode">
              <div
                data-elementor-type="container"
                data-elementor-id="7375"
                className="elementor elementor-7375"
                data-elementor-post-type="elementor_library"
              >
                <div
                  className="elementor-element elementor-element-a2d4fe3 e-flex e-con-boxed e-con e-parent"
                  data-id="a2d4fe3"
                  data-element_type="container"
                  id="contact"
                >
                  <div className="e-con-inner">
                    <div
                      className="elementor-element elementor-element-162150e elementor-button-align-stretch elementor-widget elementor-widget-form"
                      data-id="162150e"
                      data-element_type="widget"
                      id="contact"
                      data-settings='{"step_next_label":"Next","step_previous_label":"Previous","button_width":"100","step_type":"number_text","step_icon_shape":"circle"}'
                      data-widget_type="form.default"
                    >
                      <form
                        className="elementor-form"
                        method="post"
                        name="New Form"
                        onSubmit={handleSubmit}
                      >
                        <input type="hidden" name="post_id" value="7375" />
                        <input type="hidden" name="form_id" value="162150e" />
                        <input
                          type="hidden"
                          name="referer_title"
                          value="Masseter Botox Dubai | Jaw Slimming Treatment"
                        />

                        <input type="hidden" name="queried_id" value="6160" />

                        <div className="elementor-form-fields-wrapper elementor-labels-above">
                          <div className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-100">
                            <label
                              for="form-field-name"
                              className="elementor-field-label "
                              style={{ color: "black" }}
                            >
                              Name{" "}
                            </label>
                            <input
                              size="1"
                              type="text"
                              name="name"
                              value={formData.name}
                              id="form-field-name"
                              className="elementor-field elementor-size-sm  elementor-field-textual"
                              placeholder="Name"
                              onChange={handleChange}
                            />
                          </div>
                          <div className="elementor-field-type-email elementor-field-group elementor-column elementor-field-group-email elementor-col-100 elementor-field-required">
                            <label
                              for="form-field-email"
                              className="elementor-field-label"
                            >
                              Email{" "}
                            </label>
                            <input
                              size="1"
                              type="email"
                              name="email"
                              value={formData.email}
                              id="form-field-email"
                              className="elementor-field elementor-size-sm  elementor-field-textual"
                              placeholder="Email"
                              required="required"
                              onChange={handleChange}
                            />
                          </div>

                          <div className="elementor-field-type-email elementor-field-group elementor-column elementor-field-group-email elementor-col-100 elementor-field-required">
                            <label htmlFor="phone" className="form-label">
                              Enter Phone Number
                            </label>
                            <PhoneInput
                              country="ae"
                              enableSearch={true}
                              placeholder="Phone"
                              value={formData?.phone}
                              name="phone"
                              onChange={(phone) =>
                                setFormData({ ...formData, phone })
                              }
                              inputStyle={{
                                backgroundColor: "#fbf5e5",
                                width: "100%",
                                height: "40px",
                                paddingLeft: "48px",
                                borderRadius: "0.375rem",
                                border: "1px solid #ccc", // default border
                                outline: "none", // disables the blue outline
                                boxShadow: "none", // removes default browser focus shadow
                              }}
                            />
                          </div>
                          <div className="elementor-field-type-hidden elementor-field-group elementor-column elementor-field-group-utm elementor-col-100">
                            <input
                              size="1"
                              type="hidden"
                              name="form_fields[utm]"
                              id="form-field-utm"
                              className="elementor-field elementor-size-sm  elementor-field-textual"
                              value="Masseter Botox"
                            />
                          </div>
                          <div className="elementor-field-type-hidden elementor-field-group elementor-column elementor-field-group-page elementor-col-100">
                            <input
                              size="1"
                              type="hidden"
                              name="form_fields[page]"
                              id="form-field-page"
                              className="elementor-field elementor-size-sm  elementor-field-textual"
                              value="Masseter Botox"
                            />
                          </div>
                          <div className="elementor-field-group elementor-column elementor-field-type-submit elementor-col-100 e-form__buttons mt-3">
                            <button
                              className="elementor-button elementor-size-sm"
                              type="submit"
                              style={{
                                background: isSubmitting
                                  ? "#1e293b"
                                  : "#0f172a",
                                cursor: isSubmitting
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                              disabled={isSubmitting}
                            >
                              <span className="elementor-button-content-wrapper">
                                <span className="elementor-button-text">
                                  {isSubmitting ? "Submitting..." : "Book Now"}
                                </span>
                              </span>
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="elementor-element elementor-element-214034c elementor-widget elementor-widget-image"
            data-id="214034c"
            data-element_type="widget"
            data-widget_type="image.default"
          >
            <div className="d-flex justify-content-center">
              <img
                src="https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/08/tabbytamara-ss.png"
                alt=""
                style={{
                  maxWidth: "300px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <SuccessModal show={showModal} handleClose={() => setShowModal(false)} />
    </>
  );
};

export default Sideform;
